import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgCaseFolder(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31.44 33.267a10.512 10.512 0 0 1 12.613-6.6l52.392 14.04a10.512 10.512 0 0 1 7.624 12.021L96.57 94.251c-1.092 6.052-7.125 9.877-13.065 8.286l-59.16-15.853c-5.941-1.591-9.253-7.92-7.173-13.708l14.267-39.709Z"
        fill="#599F40"
      />
      <path
        d="m22.581 86.212 60.924 16.325c5.94 1.591 11.973-2.234 13.065-8.286l1.875-10.38a10.512 10.512 0 0 0-7.624-12.023L50.276 60.984c-5.94-1.592-11.973 2.234-13.066 8.286l-1.563 8.656c-1.093 6.052-7.125 9.878-13.066 8.286Z"
        fill="#78B441"
      />
      <path
        d="M63.355 69.787a5.256 5.256 0 1 1 2.72-10.154l10.154 2.721a5.256 5.256 0 0 1-2.72 10.154l-10.154-2.72Z"
        fill="#0F172A"
      />
      <path
        d="m102.194 63.109 1.875-10.38a10.512 10.512 0 0 0-7.624-12.023L39.787 25.525a5.712 5.712 0 0 1 4.143 6.533l-2.97 16.45a10.512 10.512 0 0 0 7.623 12.023L89.13 71.395c5.94 1.592 11.972-2.234 13.065-8.286Z"
        fill="#78B441"
      />
      <path
        d="M32.933 29.11a5.712 5.712 0 0 1 10.997 2.948l-8.445 46.766c-1.006 5.569-6.556 9.089-12.022 7.624-5.466-1.464-8.513-7.288-6.6-12.613l16.07-44.724Z"
        fill="#007A5F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.378 24.529c1.503-5.608 7.267-8.936 12.875-7.433l10.154 2.72c5.608 1.503 8.936 7.267 7.433 12.875l-1.36 5.077-10.154-2.72 1.36-5.078-10.154-2.72-1.36 5.077-10.154-2.721 1.36-5.077Z"
        fill="#0F172A"
      />
      <path
        d="M102.21 63.189a.8.8 0 0 1 .567.979c-1.592 5.976-7.768 9.63-13.855 8L48.377 61.304a11.313 11.313 0 0 1-8.205-12.938l.156-.861a.8.8 0 1 1 1.574.284l-.155.862a9.712 9.712 0 0 0 7.044 11.107l40.545 10.864c5.225 1.4 10.529-1.737 11.895-6.866a.8.8 0 0 1 .979-.567ZM72.836 82.768a.8.8 0 1 1 .8 1.385L67.2 87.87a.8.8 0 1 1-.8-1.385l6.437-3.717Z"
        fill="#0F172A"
      />
      <path
        d="m66.032 26.027 1.36-5.077a.8.8 0 1 1 1.545.414l-1.36 5.077a.8.8 0 1 1-1.545-.414Zm10.154 2.72 1.36-5.076a.8.8 0 0 1 1.546.414l-1.36 5.077a.8.8 0 0 1-1.546-.414Z"
        fill="#fff"
      />
    </svg>
  )
}
export default wrapIllustration(SvgCaseFolder)
